// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__mWa93","content":"styles_content__Gwn1B","selectAll":"styles_selectAll__3TG15"};